<template>
  <div>
    <div class="text-center">
      <h4 class="mt-0">{{ title }}</h4>
      <Image
        v-if="(imgSrc && imgSrc !== '') || imgSrcLocal"
        width="350"
        preview
        :src="imgSrcLocal ? imgSrcLocal : imgSrc ? siteURL + imgSrc : ''"
      />
    </div>
    <div class="text-center mt-2">
      <div class="file file--upload" :key="uploadKey">
        <label class="w-full" :for="id"> Прикріпити зображення </label>
        <input :id="id" type="file" @change="(e) => uploadIMG(e)" />
      </div>
      <Button
        class="mt-2"
        label="Видалити зображення"
        size="small"
        :disabled="!imgSrc && !imgSrcLocal"
        @click="removeIMG(imgSrc)"
      />
    </div>
  </div>
</template>

<script>
import Image from "primevue/image";
import Button from "primevue/button";
import api from "@/api/administration/index";

import { showUserNotify } from "@/helpers/notify";

export default {
  components: {
    Image,
    Button,
  },
  props: {
    img: [File, String],
    title: String,
    id: String,
    imgSrc: String,
  },
  emits: ["update:img", "update:imgSrc", "remove"],
  data() {
    return {
      siteURL: process.env.VUE_APP_API_URL,
      imgSrcLocal: null,
      uploadKey: 0,
    };
  },
  methods: {
    uploadIMG(e) {
      if (!e.target.files.length) return;

      let reader = new FileReader();

      let file = e.target.files[0];

      reader.addEventListener(
        "load",
        function () {
          this.imgSrcLocal = reader.result;
        }.bind(this),
        false
      );

      if (file) {
        if (/\.(jpe?g|png|gif|svg|webp)$/i.test(file.name)) {
          reader.readAsDataURL(file);
        } else {
          showUserNotify("error", "Невірний формат зображення!");
          return;
        }
      }
      this.$emit("update:img", file);
    },

    async removeIMG(img) {
      if (img) {
        let formData = new FormData();
        formData.append("path", img);
        try {
          await api.img.removeIMG(formData);
          showUserNotify("success", "Зображення видалено");

          this.$emit("update:imgSrc", null);
        } catch (e) {
          console.log(e);
        }
      } else {
        this.imgSrcLocal = null;
        this.uploadKey++;
      }
    },
  },
};
</script>
